import Link from 'next/link';
import { FaCheck } from 'react-icons/fa6';
import { MdOutlineFileCopy, MdOutlineFileDownload } from 'react-icons/md';
import { toast } from 'sonner';
import SlidingModal from '../home/mobile/SlidingModal';
import { useState } from 'react';
import { Button } from '../ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useSession } from '@/contexts/LitSessionProvider';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import bs58 from 'bs58';
import { Keypair } from '@solana/web3.js';
import { ENV_LIT_NETWORK } from '@shared/utils/config/environment';
import useGetWrappedWallet from '@/hooks/auth/useGetWrappedWallet';
export default function UserWallets() {
  const {
    PKP
  } = useSession();
  const {
    getSolanaWallet,
    getEVMWallet
  } = useGetWrappedWallet();
  const [isModalOpen, setModalOpen] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };
  const handleCopy = async (toCopy, index) => {
    try {
      await navigator.clipboard.writeText(toCopy);
      setCopiedIndex(index);
      toast('Copied to clipboard!', {
        position: 'bottom-right',
        description: toCopy
      });
      setTimeout(() => {
        setCopiedIndex(null);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy', error);
    }
  };
  const [activeModalWallet, setActiveModalWallet] = useState(null);
  const geniusWallets = [{
    title: 'Ethereum Networks',
    copyText: 'Copied EVM Address to Clipboard',
    key: PKP?.additionalEthAddress || 'Not Signed In',
    toCopy: PKP?.additionalEthAddress,
    privateCopyText: 'Copied EVM Private Key to Clipboard',
    privateCopy: getEVMWallet,
    tooltipText: "This Ethereum address is encrypted via your authentication method on Lit Protocol's multi-party network. You can export the private key for this address. The Genius protocol can never access your private key, it is securely encrypted on Lit's multi-party network and can only be decrypted by your authentication method. If you have assets in your default EVM Wallet, Genius automatically uses them for trading."
  }, {
    title: 'Solana',
    copyText: 'Copied Solana Address to Clipboard',
    key: PKP?.solanaAddress || 'Not Signed In',
    toCopy: PKP?.solanaAddress,
    privateCopyText: 'Copied Solana Private Key to Clipboard',
    privateCopy: getSolanaWallet,
    tooltipText: "This Solana address is encrypted via your authentication method on Lit Protocol. You can export the private key for this address. The Genius protocol can never access your private key, it is securely encrypted on Lit's multi-party network and can only be decrypted by your authentication method. If you have assets in your default Solana wallet, Genius automatically uses them for trading."
  }, {
    title: 'Sui (Default)',
    copyText: 'Copied Solana Address to Clipboard',
    key: PKP?.tronAddress || 'Coming Soon',
    tooltipText: "This Tron address is encrypted via your authentication method on Lit Protocol. You can export the private key for this address. The Genius protocol can never access your private key, it is securely encrypted on Lit's multi-party network and can only be decrypted by your authentication method. If you have assets in your default Tron wallet, Genius automatically uses them for trading."
  }
  // {
  //   title: 'Ethereum Networks (Vault)',
  //   key: PKP?.ethAddress || 'Not Signed In',
  //   toCopy: PKP?.ethAddress,
  //   tooltipText:
  //     "This Ethereum address is tied to your authentication method. You won't be able to export the private key for this address as it is sharded across Lit Nodes. It is only accessible through your authentication method. Assets sent to this wallet are currently not enabled for trading but will be shortly",
  // },
  // {
  //   title: 'Lit Protocol Information',
  //   toCopy: PKP?.publicKey,
  //   copyText: 'Copied Public Key to Clipboard',
  //   key: (
  //     <div className='flex flex-col gap-1 break-all'>
  //       <p>Public Key: {PKP?.publicKey}</p>{' '}
  //       {PKP?.tokenId?.hex && (
  //         <Link
  //           className='underline hover:cursor-pointer md:hover:text-genius-pink transition-all duration-300'
  //           target='_blank'
  //           href={`https://searchlit.io/v1/nft/0x58582b93d978f30b4c4e812a16a7b31c035a69f7/${BigInt(PKP?.tokenId?.hex, 16)?.toString()}`}
  //         >
  //           PKP NFT #: {BigInt(PKP?.tokenId?.hex, 16)?.toString()}
  //         </Link>
  //       )}
  //       <p className='capitalize'>Network: {ENV_LIT_NETWORK}</p>
  //     </div>
  //   ),
  //   info: 'Your Public Key and Token ID are used to identify your account on the Lit Protocol and facilitates signing transactions across networks.',
  // },
  ];
  return <>
      {geniusWallets.map((wallet, index) => {
      return <div className='w-full px-4 lg:px-2 pr-6 py-[10px]  flex justify-between items-center break-all' key={index}>
            <div className={`w-5/6 flex flex-col gap-y-1 ${!wallet.toCopy && 'w-full'}`}>
              <p className=' text-genius-cream text-base/4 flex'>
                {wallet.title}{' '}
                {wallet?.tooltipText && <TooltipProvider delayDuration={100}>
                    <Tooltip>
                      <TooltipTrigger>
                        <IoMdInformationCircleOutline className='text-genius-cream/50 ml-1' size={12} />
                      </TooltipTrigger>
                      <TooltipContent className='p-0 ml-[200px]'>
                        <div className='text-xs text-genius-cream max-w-sm bg-genius-blue p-2'>
                          {wallet.tooltipText}
                        </div>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>}
              </p>
              <div className='break-all flex items-center pr-4'>
                {' '}
                <p className='text-xs/3 text-genius-cream/50 tracking-tighter'>{wallet.key}</p>
              </div>
            </div>
            {wallet.info && <></>}
            {wallet.privateCopy && <div className='flex w-1/6 items-center ta-r'>
                <div className='flex flex-col w-2/4'>
                  <MdOutlineFileDownload size={16} onClick={() => {
              setActiveModalWallet(wallet);
              toggleModal();
            }} />
                </div>
                <SlidingModal heightFit={true} key={index + 'modal'} isOpen={isModalOpen} onClose={toggleModal}>
                  <div className='flex flex-col p-4 pb-1'>
                    <h1 className='text-sm font-light w-full ta-l'>Export Wallet Private Key</h1>
                    <div className='mb-6 rounded-md bg-genius-blue p-6 text-xs text-genius-cream/50 ta-l '>
                      *******************************
                    </div>
                    <Button onClick={async () => {
                const id = toast.loading('Exporting Private Key...');
                try {
                  console.log('wallet.privateCopy', activeModalWallet.privateCopy);
                  const privateKey = await activeModalWallet.privateCopy();
                  let rawText;
                  if (privateKey instanceof Keypair) {
                    rawText = bs58.encode(privateKey.secretKey);
                  } else {
                    rawText = privateKey?.privateKey;
                  }
                  await navigator.clipboard.writeText(rawText);
                  toast.success('Copied Private Key to Clipboard', {
                    id,
                    duration: 2000
                  });
                } catch (error) {
                  //clear  id
                  toast.dismiss(id);
                  toast.error('There was an issue exporting your private key. Please refresh the page and try again');
                }
                toggleModal();
              }} className='text-genius-blue rounded-full w-full mx-auto py-2 h-14 bg-genius-pink'>
                      <MdOutlineFileCopy className='mr-4' size={14} />
                      Copy Private Key
                    </Button>
                  </div>
                </SlidingModal>
              </div>}
            {wallet.toCopy && <div className='flex flex-col ' onClick={() => handleCopy(wallet.toCopy, index)}>
                {copiedIndex === index ? <FaCheck className='text-green-400' size={14} /> : <MdOutlineFileCopy size={14} />}
              </div>}
          </div>;
    })}
    </>;
}